import QS from 'qs'
import base from '@/untils/base'
import axios from '@/untils/http'

/** 获取文件夹 */
export const getFilesSelectFolder = (data) => {
  return axios({
    url: `${base.url}/files/selectFolder`,
    method: 'get',
    params: data,
  })
}

/** 获取文件 */
export const getFilesSelectDocumentNew = (data) => {
  return axios({
    url: `${base.url}/files/selectDocumentNew`,
    method: 'get',
    params: data,
  })
}

/** 新增文件夹或文件 */
export const postFilesAddFiles = (data) => {
  return axios({
    url: `${base.url}/files/addFiles`,
    method: 'post',
    data: QS.stringify(data),
  })
}

/** 修改文件夹 */
export const putFilesUpdateFiles = (data) => {
  return axios({
    url: `${base.url}/files/updateFilesNew`,
    method: 'put',
    data: QS.stringify(data),
  })
}

/** 删除文件或文件 */
export const deleteFilesDeleteFiles = (data) => {
  return axios({
    url: `${base.url}/files/deleteFiles?id=${data.id}&password=${data.password}`,
    method: 'delete',
  })
}

/** 校验密码 */
export const postCheckCheckpwd = (data) => {
  return axios({
    url: `${base.url}/check/checkpwd`,
    method: 'post',
    data: QS.stringify(data),
  })
}

/** 下载文件 */
export const postFilesDownloadZip = (data) => {
  return axios({
    url: `${base.url}/files/downloadZip`,
    method: 'post',
    data: QS.stringify(data),
    responseType: 'blob',
  })
}

/** 合并文件夹 */
export const postFilesMergeFolderOrFile = (data) => {
  return axios({
    url: `${base.url}/files/mergeFolderOrFile`,
    method: 'post',
    data: QS.stringify(data),
  })
}

/** 获取文件夹字典 */
export const postFilesQuertFilesDict = (data) => {
  return axios({
    url: `${base.url}/files/quertFilesDict`,
    method: 'post',
    data: QS.stringify(data),
  })
}

/** 移动文件夹或文件 */
export const postFilesMoveFolderOrFile = (data) => {
  return axios({
    url: `${base.url}/files/moveFolderOrFile`,
    method: 'post',
    data: QS.stringify(data),
  })
}

/** 排序 */
export const postFilesSortFolderOrFile = (data) => {
  return axios({
    url: `${base.url}/files/sortFolderOrFile`,
    method: 'post',
    headers: { 'Content-Type': 'application/json;charset=utf-8' },
    data: data,
  })
}
